import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/loginUsuario`

export function loguearUsuario(loginData) {
  return http.post(`${API_ENDPOINT}/loguearUsuario/`, loginData)
}

export function validarUsuario(loginData) {
  return http.post(`${API_ENDPOINT}/validarUsuario/`, loginData)
}

export function RecuperarPassword(loginData) {
  return http.post(`${API_ENDPOINT}/recuperarPassword/`, loginData)
}

export function cambiarPassword(loginData) {
  return http.post(`${API_ENDPOINT}/cambiarPassword/`, loginData)
}

export function requestToken(loginData) {
  return http.post(`${API_ENDPOINT}/requestToken/`, loginData)
}
